import { render } from "./FileCorner.vue?vue&type=template&id=a48ee360"
import script from "./FileCorner.vue?vue&type=script&lang=js"
export * from "./FileCorner.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__